import { types } from '../actions/types';

const initialState = [];

export const dfp_data = ( state = initialState, action ) => {
    const newState = [ ...state ];

    switch( action.type ) {
        case types.GET_GOOGLE_DFP_REQUEST: return setAdvertsState( newState, [] );
        case types.GET_GOOGLE_DFP_ERROR: return setAdvertsState( newState, [] );
        case types.GET_GOOGLE_DFP_SUCCESS: 
            return setAdvertsState( newState, action.data );
            default: return newState;
    }
};

function setAdvertsState( newState, data ) {

    newState = data;
    //console.log(newState);
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/reducers/data.js